import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <i
      class="pi pi-question-circle"
      tooltipPosition="top"
      fitContent="true"
      style="font-size: 1.5rem"
    ></i>
  `
})
export class TooltipTypeComponent extends FieldArrayType {}
